module.exports = __webpack_public_path__ + "img/logo11@2x.696d45e0.png";